export const REGION_COLORS = [
  "#65b0b0",
  "#6274ad",
  "#b5d894",
  "#edb7ce",
  "#dfbf59",
  "#b5a5cf",
  "#d8aa82",
];
